// buttons used across the address components (same as the profile buttons)
const primaryBtn = {
  background: "#f19e38",
  color: "#fff",
  minHeight: 44,
  "&:hover": {
    background: "#f19e38",
    color: "#fff",
  },
};

const secondaryBtn = {
  border: "1px solid #f19e38",
  color: "#f19e38",
  minHeight: 44,
  "&:hover": {
    border: "1px solid #f19e38",
    color: "#f19e38",
  },
};

export { primaryBtn, secondaryBtn };
